import { Component, OnInit, Sanitizer } from '@angular/core';
import {
  ApiService,
  CoreUiPartialState,
  getApplicationName,
  getArbCentralNavSecurity,
  getOrderTypes,
  isExternalUser,
  isProgrammeUser,
  loadCommunicationGroupList,
} from '@pos-app/core-ui';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { IOOEUserState } from '../epc/models/userState.model';
import { OOESessionService } from '@pos-app/core-ui/lib/services/ooe-session.service';
import { CentralPartialState } from './+state/central.reducer';
import { F } from '@angular/cdk/keycodes';
import { FetchMyHelpComponents } from './+state/central.actions';
import { centralQuery } from './+state/central.selectors';
import { takeUntil } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { NgIf, NgStyle, AsyncPipe } from '@angular/common';
import { HelpYouSellComponent } from './components/help-you-sell/help-you-sell.component';
import { CentralNotificationComponent } from './components/notification/central-notification.component';
import { HelpHowToComponent } from './components/help-how-to/help-how-to.component';

@Component({
    selector: 'app-central',
    templateUrl: './central.component.html',
    styleUrls: ['./central.component.scss'],
    imports: [NgIf, NgStyle, HelpYouSellComponent, CentralNotificationComponent, HelpHowToComponent, AsyncPipe]
})
export class CentralComponent implements OnInit {
  public isExternalUser$: Observable<boolean>;
  public isProgrammeUser$: Observable<boolean>;
  public applicationName$: Observable<string>;
  public arbCentralSecurityFunctions$: Observable<boolean>;
  public showIframe = false;
  public iframeUrl: any = null;
  public entityTabIndex = -1;
  orderTypes: Observable<any>;
  isShowRows = false;
  helpHowToComponent: any;
  helpMessage: string;
  headerPictureURL: string;

  private unSubscribe$ = new Subject<void>();

  // Getter for OOE User State
  public get ooeUserState(): IOOEUserState {
    return this.ooeSessionService.getOOEUserState();
  }
  constructor(
    private coreUiStore: Store<CoreUiPartialState>,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private ooeSessionService: OOESessionService,
    private store: Store<CentralPartialState>,
    private router: Router,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    //get user role
    this.store.dispatch(new FetchMyHelpComponents());
    this.applicationName$ = this.coreUiStore.select(getApplicationName);
    this.isExternalUser$ = this.coreUiStore.select(isExternalUser);
    this.isProgrammeUser$ = this.coreUiStore.select(isProgrammeUser);
    this.orderTypes = this.coreUiStore.pipe(select(getOrderTypes))
    // this.coreUiStore.dispatch(loadCommunicationGroupList());
    this.store.pipe(select(centralQuery.getMyHelpComponents), takeUntil(this.unSubscribe$)).subscribe((data) => {
      this.helpHowToComponent = data?.tileArray || [];
      
      this.helpMessage = this.sanitizer.bypassSecurityTrustHtml(data?.headerText || '') as string;
      this.headerPictureURL = data?.headerPictureURL || '';
    });
    this.arbCentralSecurityFunctions$ = this.coreUiStore.select(getArbCentralNavSecurity);
    if (this.route.snapshot.queryParams.relaodUserState === 'true') {
      this.ooeSessionService.fetchUserState().subscribe({
        next: (userState) => {
          this.ooeSessionService.setOOEUserState(userState);
          this.router.navigate(['/central']);
        },
        error: (error) => {
          console.error('Error reloading user state:', error);
        },
      });
    }
  }
}

